<template>

  <div class="container" id="wordcomponent">
    <div 
      v-for="(guessRows, guessRowsIndex) of guessRows"
      :key="guessRows"
      :id="guessRowsIndex"
      :ref="'guessRow' + guessRowsIndex"
      class="row">
        <span 
          v-for="(guessLetter, guessIndex) of guessRows"
          :key="guessLetter"
          v-bind:id="'guessRow-' + guessRowsIndex + '-tile' + guessIndex"
          data="letter"
          class="letter pop">
          {{guessLetter}}
        </span>
      </div>

  </div>

</template>
<script>
export default{
  data(){
    return{
      guessRows: null
    }
  },

  mounted(){
    if(window.localStorage.getItem('myGuesses') == null){
      this.guessRows = this.$store.state.guessRows
    }else{
      this.guessRows = JSON.parse(window.localStorage.getItem('myGuesses'))
    }
  }
}
</script>
<style lang="scss">
.letter{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  border: 2px solid #3a3a3a;
  padding: 5px;
  margin: 2px;
  font-size: 2rem;
  text-transform: uppercase;
}
.row{
  display: flex;
  flex-direction: row;
}
</style>